import React, { useState, useEffect } from 'react';

/**
 * Full-screen loading overlay with animated dots.
 * Props:
 *   visible  — boolean to show/hide
 *   text     — optional loading message (default: "Memuat data...")
 */
const LoadingOverlay = ({ visible, text = 'Memuat data...' }) => {
  const [shouldRender, setShouldRender] = useState(visible);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
      setExiting(false);
    } else if (shouldRender) {
      setExiting(true);
      const timer = setTimeout(() => {
        setShouldRender(false);
        setExiting(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [visible, shouldRender]);

  if (!shouldRender) return null;

  return (
    <div className={`loading-overlay ${exiting ? 'loading-overlay-exit' : ''}`}>
      <div className="loading-spinner-container">
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        {text && <div className="loading-text">{text}</div>}
      </div>
    </div>
  );
};

export default LoadingOverlay;
